import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

export const RESOURCE_USER_ROLES_QUERY = gql`
  query GetResourceUserRoles(
    $page: Int
    $pagesize: Int
    $filter: GetResourceUsersFilter
  ) {
    resourceUsers2(page: $page, pagesize: $pagesize, filter: $filter) {
      id
      uri
      displayText
      roles {
        projectRole {
          id: uri
          displayText
        }
        isPrimary
      }
    }
  }
`;
export const useResourceUserPrimaryRole = ({
  userId,
  page,
  pageSize,
  skip
}) => {
  const { loading, error, data } = useQuery(RESOURCE_USER_ROLES_QUERY, {
    variables: { page, pagesize: pageSize, filter: { userIds: [userId] } },
    skip,
    fetchPolicy: 'cache-and-network'
  });

  return {
    loading,
    primaryRole: (data?.resourceUsers2?.[0]?.roles || []).find(r => r.isPrimary)
      ?.projectRole,
    error
  };
};

export default useResourceUserPrimaryRole;
